import { Box, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import PDFLogo from '../../assets/images/pdf.svg'
import { FormRiderModel } from "../../models/formRider";
import { openUrl } from "../../utils/openUrl";
import { useTranslation } from "react-i18next";
import useFormRiderRegister from "./controller/form";
import ConfirmDialog from "../../components/ConfirmDialog";

interface Props {
    onClose: VoidFunction,
    dataFormRider: FormRiderModel | any,
    onFetchData: Function
}

const FormRiderView = ({ onClose, dataFormRider, onFetchData }: Props) => {
    const { t } = useTranslation('global');
    const controller = useFormRiderRegister({ selectData: dataFormRider, onFetchData, onClose })
    return (
        <Box>
            <IconButton onClick={() => { onClose() }} sx={{ mb: 2 }}>
                <KeyboardBackspaceIcon />
            </IconButton>
            <Typography variant="h4">{t("registerFormRider_page.Driver detail")}</Typography>
            <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={8} md={8}>
                    <Box
                        sx={{
                            p: 4,
                            boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            borderRadius: '10px'
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Typography>{t("registerFormRider_page.First name")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    margin="normal"
                                    value={dataFormRider?.firstName}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography>{t("registerFormRider_page.Last name")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    margin="normal"
                                    value={dataFormRider?.lastName}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography>{t("registerFormRider_page.Gender")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    value={dataFormRider?.gender}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography>{t("registerFormRider_page.Date of Birth")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    value={dataFormRider?.dateOfBirth}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography>{t("registerFormRider_page.Phone number")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    value={dataFormRider?.phoneNumber}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography>{t("registerFormRider_page.Second Phone number")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    value={dataFormRider?.secondPhone}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography>{t("registerFormRider_page.address")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    value={dataFormRider?.homeAddress}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    multiline
                                    rows={4}
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ display: dataFormRider?.confirm === true ? 'none' : 'flex', justifyContent: 'right', mt: 1 }}>
                            <Button variant="contained" color="secondary" sx={{ color: '#fff', textTransform: 'none' }} onClick={() => controller.handleOpenConfirmForm()}>
                                {t("registerFormRider_page.Confirm Form")}
                            </Button>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <Box
                        sx={{
                            p: 4,
                            boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            borderRadius: '10px',
                            height: 'auto'
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Box>
                                        <Typography variant="h6">{t("registerFormRider_page.identity Card PDF")}</Typography>
                                        <Box sx={{ cursor: 'pointer' }} onClick={() => openUrl(dataFormRider?.identityCardPDF)}>
                                            <img src={PDFLogo} alt="pdf" style={{ width: '150px' }} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Box>
                                        <Typography variant="h6">{t("registerFormRider_page.certificate Current Home PDF")}</Typography>
                                        <Box sx={{ cursor: 'pointer' }} onClick={() => openUrl(dataFormRider.certificateCurrentHomePDF)}>
                                            <img src={PDFLogo} alt="pdf" style={{ width: '150px' }} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Box>
                                        <Typography variant="h6">{t("registerFormRider_page.certificate Criminal Record PDF")}</Typography>
                                        <Box sx={{ cursor: 'pointer' }} onClick={() => openUrl(dataFormRider.guaranteePDF)}>
                                            <img src={PDFLogo} alt="pdf" style={{ width: '150px' }} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Box>
                                        <Typography variant="h6">{t("registerFormRider_page.guarantee PDF")}</Typography>
                                        <Box sx={{ cursor: 'pointer' }} onClick={() => openUrl(dataFormRider.guaranteePDF)}>
                                            <img src={PDFLogo} alt="pdf" style={{ width: '150px' }} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Box>
                                        <Typography variant="h6">{t("registerFormRider_page.vehicle Registration PDF")}</Typography>
                                        <Box sx={{ cursor: 'pointer' }} onClick={() => openUrl(dataFormRider.vehicleRegistrationPDF)}>
                                            <img src={PDFLogo} alt="pdf" style={{ width: '150px' }} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <ConfirmDialog
                open={controller.openConfirm}
                title={t("registerFormRider_page.Do you want to confirm this form")}
                loading={controller.loadingConfirm}
                onCancel={() => controller.handleCloseConfirmForm()}
                onConfirm={() => controller.handleConfirmFormRiderRegister()}
            />
        </Box>
    )
}
export default FormRiderView;